import React, { useEffect, useMemo, useState } from "react";
import { MediaItem, listMedia } from "./media-api";
import Select from 'react-select';
import { monthName } from "simple-utils/dist/date-utils";
import { groupBy } from "simple-utils";
import { MediaType } from "./media-type";
import { MediaPreviewBox } from "./media-preview";

type Option = {value: number, label: string, month: string}
type Group = {label:string, options:Option[]}


export function MediaMenu({value, onChange}:{value:number, onChange:(v:number) => void}){
    const [options, setOptions] = useState<Option[]>([]);
    const [data, setData] = useState<Group[]>([]);
    const [list, setList] = useState<MediaItem[]>([]);
    

    const selected = useMemo(() => {
        return options.find(o => o.value === value)
    }, [options, value])

    const media = useMemo(() => {
        return list.find(o => o.id == value)
    }, [options, value])

    useEffect(() => {
        (async () => {
            const medias = await listMedia();
            setList(medias);
            const options = medias.map(a => ({value: a.id, label: a.name, month: `${monthName(a.created)} de ${a.created.getFullYear()}`}))
            setOptions(options);
            const map = groupBy(options, o => o.month);
            const groups:Group[] = [];
            for(let [label, options] of Object.entries(map)){
                groups.push({label, options})
            }
            setData(groups);
        })()
    }, [])

    return <>
        <Select classNamePrefix="react-select-city" placeholder="Mídia..." noOptionsMessage={() => "Não encontrado"} isLoading={options.length == 0} options={data} value={selected || ""} onChange={(e:any) => onChange(e.value)} />
        {media != null && <>
            <div className="mb-2 mt-3 text-center"><MediaType media={media} />
                <a className="btn-link ms-2" onClick={() => onChange(null)}><i className="fa fa-ban"></i></a>
            </div>
            <MediaPreviewBox media={media} short={true} />
            {/*media.mimetype.startsWith("video") && <div className="text-center mt-3 mb-2"><span className="badge bg-danger d-block text-wrap" style={{lineHeight: "1.3em"}}>O envio de vídeo está limitado temporariamente. Por favor troque por outro tipo de mídia como imagem ou audio.</span></div> */}
            {media.mimetype.startsWith("audio") && <div className="text-center mt-3 mb-2"><span className="badge bg-info">O texto será ignorado para mensagens com audio.</span></div>}
        </>}
    </>
}